module.exports = __webpack_public_path__ + "assets/img/smartTV-module5-8.134d963b.jpg";